<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 23 22">
    <path
      d="M2.021 20.5813L1.92161 20.834L2.16115 20.7062L22.8774 9.64882L23.0707 9.54565L22.8661 9.46722L0.939294 1.06231L0.685757 0.965126L0.815695 1.20354L5.94287 10.611L2.021 20.5813ZM20.0784 9.30771L6.6549 10.1382L2.5343 2.58082L20.0784 9.30771ZM3.55568 19.0017L6.708 10.9919L20.1309 10.1526L3.55568 19.0017Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
